import { render } from "./LikeShopItem.vue?vue&type=template&id=cadc7f3e&scoped=true"
import script from "./LikeShopItem.vue?vue&type=script&lang=js"
export * from "./LikeShopItem.vue?vue&type=script&lang=js"

import "./LikeShopItem.vue?vue&type=style&index=0&id=cadc7f3e&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadc7f3e"]])

export default __exports__